import TemplatesPage, { TemplatesPageProps } from './TemplatesPage';
import withPresenter from './TemplatesPage.presenter';
import withInteractor from './TemplatesPage.interactor';

const TemplatePage = withInteractor(withPresenter(TemplatesPage));

export type { TemplatesPageProps };
export default TemplatePage;
